/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ConnectionQualityType {
    NOT_CONNECTED = 'NOT_CONNECTED',
    CABLE = 'CABLE',
    BAD_RSSI = 'BAD_RSSI',
    MEDIUM_RSSI = 'MEDIUM_RSSI',
    GOOD_RSSI = 'GOOD_RSSI',
    EXCELLENT_RSSI = 'EXCELLENT_RSSI'
}


export function ConnectionQualityTypeFromJSON(json: any): ConnectionQualityType {
    return ConnectionQualityTypeFromJSONTyped(json, false);
}

export function ConnectionQualityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectionQualityType {
    return json as ConnectionQualityType;
}

export function ConnectionQualityTypeToJSON(value?: ConnectionQualityType | null): any {
    return value as any;
}

